import * as React from 'react';
import { illustrationColors } from '../colors';
import { getColorValue } from '../utilities/color';

function Done(props) {
  const green = getColorValue('illustrationGreen');
  const checkBlue = getColorValue('illustrationCheckBlue');

  return (
    <svg fill="none" height="275" viewBox="0 0 275 275" width="275" {...props}>
      <path
        d="m211.23 158.759c1.16-6.5 1.76-13.39 1.76-20.71s-.62-14.4-1.8-20.98c-7.02-39.14-34.22-63.26-72.35-69.47-6.51-1.05-13.33-1.6-20.42-1.6s-14.51.58-21.27 1.72c-38.15 6.37-65.29 30.44-72.34 69.35-1.19 6.57-1.81 13.57-1.81 20.98s.61 14.21 1.77 20.71c6.99 38.87 34.16 62.98 72.37 69.35 6.76 1.13 13.87 1.72 21.27 1.72s13.92-.54 20.42-1.6c38.19-6.2 65.4-30.38 72.38-69.47z"
        fill={green}
      />
      <path
        d="m151.03 137.368 73.12-76.1698 27.04 25.04-106.21 91.1698-49.9995-46.07 25.9995-30.02 30.04 36.06z"
        fill={checkBlue}
      />
      <path
        d="m211.21 117.079c-2.08-11.54-5.91-21.8001-11.26-30.6601l-48.91 50.9501-30.04-36.06-26 30.02 50 46.07 66.72-57.27c-.15-1.03-.31-2.05-.49-3.06z"
        fill={illustrationColors.staticDarkBlue}
      />
    </svg>
  );
}

export default Done;
